import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Calculation, CalculationItem } from "./calculation";

@Component({
    selector: 'app-stamp-duty-calculator',
    templateUrl: './stamp-duty-calculator.component.html',
    styleUrls: ['./stamp-duty-calculator.component.scss']
})
export class StampDutyCalculatorComponent implements OnInit {

    stampDutyForm: FormGroup;
    resultCalculation: Calculation = null;

    constructor(private readonly fb: FormBuilder) {}

    ngOnInit() {
        this.stampDutyForm = this.fb.group({
            position: "single",
            purchasePrice: ["", [Validators.required]]
        });
    }

    calculate(): void {
        switch (this.stampDutyForm.get("position").value) {
        case "single":
                this.resultCalculation = this.calculateSingle();
                this.calcType = "single property";
                return;
        case "additional":
                this.resultCalculation = this.calculateAdditional();
                this.calcType = "additional property";
                return;
        case "first":
                this.resultCalculation = this.calculateFtb();
                this.calcType = "first time buyer";
                return;
        }
        this.resultCalculation = null;
    }

    back(): void {
        this.resultCalculation = null;
    }

    calcType: string;
    note: string;

    private calculateSingle() : Calculation {
        const calculator = this.defaultSingle();
        calculator.calculate(this.stampDutyForm.get("purchasePrice").value);

        this.note = "";

        return calculator;
    }

    private calculateAdditional(): Calculation {
        const calculator = this.defaultAdditional();
        calculator.calculate(this.stampDutyForm.get("purchasePrice").value);

        this.note = "";

        return calculator;
    }

    private calculateFtb(): Calculation {
        const price = this.stampDutyForm.get("purchasePrice").value;
        if (price > 500000)
            return this.calculateSingle();

        const calculator = this.defaultFtb();
        calculator.calculate(price);

        this.note = "* For purchases over &pound;500k, Stamp Duty Land Tax (SDLT) is charged at 2% from &pound;125k to &pound;250k and 5% from &pound;250k to &pound;925k.";

        return calculator;
    }

    private defaultSingle(): Calculation {
        const calc = new Calculation();

        calc.ranges = new Array<CalculationItem>();

        calc.ranges.push(new CalculationItem("Less than &pound;125,000", 0, 0, 125000));
        calc.ranges.push(new CalculationItem("&pound;125,000 to &pound;250,000", 2, 125000, 250000));
        calc.ranges.push(new CalculationItem("&pound;250,000 to &pound;925,000", 5, 250000, 925000));
        calc.ranges.push(new CalculationItem("&pound;925,000 to &pound;1.5 million", 10, 925000, 1500000));
        calc.ranges.push(new CalculationItem("Over &pound;1.5 million", 12, 1500000, 1000000000));

        this.note = "";

        return calc;
    }

    private defaultAdditional(): Calculation {
        const calc = this.defaultSingle();

        calc.ranges = new Array<CalculationItem>();

        calc.ranges.push(new CalculationItem("Less than &pound;125,000", 3, 0, 125000));
        calc.ranges.push(new CalculationItem("&pound;125,000 to &pound;250,000", 5, 125000, 250000));
        calc.ranges.push(new CalculationItem("&pound;250,000 to &pound;925,000", 8, 250000, 925000));
        calc.ranges.push(new CalculationItem("&pound;925,000 to &pound;1.5 million", 13, 925000, 1500000));
        calc.ranges.push(new CalculationItem("Over &pound;1.5 million", 15, 1500000, 1000000000));
        
        this.note = "";

        return calc;
    }

    private defaultFtb(): Calculation {
        const calc = new Calculation();

        calc.ranges = new Array<CalculationItem>();

        calc.ranges.push(new CalculationItem("Less than &pound;300,000", 0, 0, 300000));
        calc.ranges.push(new CalculationItem("&pound;300,000 to &pound;500,000", 5, 300000, 500000));

        return calc;
    }
}
